/* Belle's — "What's your popcorn personality?" quiz.
   Data + logic in one file so the Shopify section and the standalone preview
   behave identically. Mount by calling BellesQuiz.mount(rootEl). */
(function () {
  var CHARS = {
    ameer:    { name: 'Ameer Pistashi',      flavor: 'Dubai-Style Chocolate',      handle: 'dubai-style-chocolate', art: 'char-ameer-pistashi.png',      accent: '#5C6B25', blurb: 'A social butterfly, prince charming, a little spoiled but extremely generous. Throws the most lavish parties and knows how to have a good time.' },
    cooker:   { name: 'Cooker Crumbleton',   flavor: 'Cookies & Cream',            handle: 'cookies-and-cream',     art: 'char-cooker-crumbleton.png',   accent: '#7936AD', blurb: 'A seasoned entrepreneur and salesperson that always has the perfect pitch. Center of attention, loves a good happy-hour and fancy dinners.' },
    matt:     { name: 'Matt Cha',            flavor: 'Matcha Latte',               handle: 'matcha-latte',          art: 'char-matt-cha.png',            accent: '#00A99D', blurb: 'Calm, considered and quietly cool. First one at the cafe, last one to raise their voice — the friend everyone texts for advice.' },
    sweeton:  { name: 'Sweeton Carawell',    flavor: 'Caramel',                    handle: 'caramel',               art: 'char-sweeton-carawell.png',    accent: '#C96C09', blurb: 'Warm, steady and impossible not to like. Cooks low and slow, remembers your birthday, and always brings something to share.' },
    cakely:   { name: 'Cakely Sprinklestein',flavor: 'Birthday Cake',              handle: 'birthday-cake-1',         art: 'char-cakely-sprinklestein.png',accent: '#D22A6F', blurb: 'Finds a reason to celebrate on a Tuesday. Loud, generous, sprinkles on everything — the one who organises the group gift.' },
    yammy:    { name: 'Yammy Ube',           flavor: 'White Chocolatey Ube',       handle: 'white-chocolatey-ube-1',                   art: 'char-yammy-ube.png',           accent: '#7936AD', blurb: 'Purple on purpose. Curious, a little contrary, and always the first to try the thing nobody has heard of yet.' },
    coco:     { name: 'Coco Drizelle',       flavor: 'Chocolate Drizzle',          handle: 'chocolatey-drizzle',     art: 'char-coco-drizelle.png',       accent: '#5A4632', blurb: 'Goes over everything, in the best way. Generous to a fault, deeply comforting, and never subtle about it.' },
    pea:      { name: 'Pea Nutly',           flavor: 'Peanut Butter',              handle: 'peanut-butter-crunch',         art: 'char-pea-nutly.png',           accent: '#C96C09', blurb: 'Straightforward, sturdy, no nonsense. Made with actual peanuts and actual opinions — you always know where you stand.' },
    dillon:   { name: 'Dillon Relishman',    flavor: 'Dill Pickle',                handle: 'dill-pickle-1',           art: 'char-dillon-relishman.png',    accent: '#5C6B25', blurb: 'Brine is a personality. Sharp, funny, slightly chaotic — the friend whose group chat messages you read twice.' },
    sunny:    { name: 'Sunny Meyer',         flavor: 'Lemon',                      handle: 'lemon-meringue-1',                 art: 'char-sunny-meyer.png',         accent: '#C9A227', blurb: 'Zest first, questions later. Bright, quick and a little tart — brings the energy up the moment they walk in.' },
    cary:     { name: 'Cary Saltz',          flavor: 'Salted Caramel',             handle: 'salted-caramel',        art: 'char-cary-saltz.png',          accent: '#C96C09', blurb: 'Original recipe, still undefeated. Balanced, reliable, universally loved — the one everyone can agree on.' },
    kettleby: { name: 'Kettleby Kernelson',  flavor: 'Avocado Kettle Corn',        handle: 'avocado-kettle-corn',   art: 'char-kettleby-kernelson-avocado.png', accent: '#5C6B25', blurb: 'Simple, done properly. Outdoorsy, unfussy and quietly disciplined — the one who actually packed snacks for the hike.' },
    zincwell: { name: 'Zincwell Bloomberry', flavor: 'Very Berry',                 handle: 'very-berry',            art: 'char-zincwell-bloomberry.png', accent: '#2E9BBF', blurb: 'Immunity and wellness with elderberry and echinacea. Prepared for everything, thriving in February, and happy to tell you how.' },
    javi:     { name: 'Javi Brews',          flavor: 'Caf\u00e9 Latte',            handle: 'cafe-latte',            art: 'char-javi-brews.png',          accent: '#8A6A4A', blurb: 'Energy and focus, no jitters invited. Runs on ambition and caffeine, ships things early, still answers texts.' },
    rosie:    { name: 'Rosie Glowsome',      flavor: 'Raspberry Rose',             handle: 'raspberry-rose',        art: 'char-rosie-glowsome.png',      accent: '#C24A80', blurb: 'Beauty and glow, petals included. Romantic, self-aware and unbothered — makes ordinary evenings feel like an occasion.' }
  };

  /* Companion flavors per character, so a result recommends a box's worth rather
     than a single bag. Keys are CHARS keys; edit freely — anything unknown is
     ignored, and the builder skips handles it cannot buy. */
  var KIN = {
    ameer:    ['coco', 'matt'],
    cooker:   ['cakely', 'coco'],
    matt:     ['yammy', 'javi'],
    sweeton:  ['cary', 'pea'],
    cakely:   ['cooker', 'sunny'],
    yammy:    ['matt', 'rosie'],
    coco:     ['ameer', 'cooker'],
    pea:      ['sweeton', 'cary'],
    dillon:   ['kettleby', 'cary'],
    sunny:    ['cakely', 'rosie'],
    cary:     ['sweeton', 'kettleby'],
    kettleby: ['dillon', 'cary'],
    zincwell: ['rosie', 'javi'],
    javi:     ['matt', 'zincwell'],
    rosie:    ['zincwell', 'sunny']
  };

  function boxUrl(root, keys) {
    var base = root.getAttribute('data-box-url') || '/pages/build-a-box';
    var handles = keys.map(function (k) { return CHARS[k] && CHARS[k].handle; }).filter(Boolean);
    return base + (handles.length ? '?flavors=' + encodeURIComponent(handles.join(',')) : '');
  }

  var QUESTIONS = [
    { q: "It's Friday night. Where do we find you?",
      a: [
        { t: 'Hosting — the good glassware is out',      w: { ameer: 3, cooker: 2, cakely: 1 } },
        { t: 'On the sofa, one perfect film, lights low', w: { coco: 3, matt: 2, rosie: 1 } },
        { t: 'Out somewhere new nobody has tried yet',    w: { yammy: 3, dillon: 2, sunny: 1 } },
        { t: 'Early night. Tomorrow starts at six',       w: { javi: 3, kettleby: 2, zincwell: 1 } }
      ] },
    { q: 'Pick your order.',
      a: [
        { t: 'Ceremonial matcha, no sugar',         w: { matt: 3, rosie: 1 } },
        { t: 'Double espresso, standing up',        w: { javi: 3, cooker: 1 } },
        { t: 'Salted caramel everything',           w: { sweeton: 3, coco: 2 } },
        { t: 'Something pink with a flower in it',  w: { rosie: 3, cakely: 2 } }
      ] },
    { q: 'Your friends would say you are…',
      a: [
        { t: 'The reliable one',      w: { cary: 3, pea: 2, kettleby: 1 } },
        { t: 'The funny one',         w: { dillon: 3, sunny: 2 } },
        { t: 'The generous one',      w: { ameer: 3, coco: 2, sweeton: 1 } },
        { t: 'The one with a plan',   w: { javi: 3, zincwell: 2, cooker: 1 } }
      ] },
    { q: 'A bag of popcorn appears. What happens?',
      a: [
        { t: 'I share it. Obviously',            w: { sweeton: 3, ameer: 2, cary: 1 } },
        { t: 'I hide it from my own family',     w: { coco: 3, cooker: 2 } },
        { t: 'I read the ingredients first',     w: { zincwell: 3, kettleby: 2, pea: 1 } },
        { t: 'It is gone. Was there a bag?',     w: { cakely: 3, sunny: 2, dillon: 1 } }
      ] },
    { q: 'What are you actually after right now?',
      a: [
        { t: 'Comfort',                w: { coco: 3, sweeton: 2, cary: 1 } },
        { t: 'A little adventure',     w: { yammy: 3, dillon: 2, ameer: 1 } },
        { t: 'To feel looked after',   w: { rosie: 3, zincwell: 2, matt: 1 } },
        { t: 'To get things done',     w: { javi: 3, pea: 2, cooker: 1 } }
      ] },
    { q: 'Last one. Pick a Saturday morning.',
      a: [
        { t: 'Farmers market, canvas bag',       w: { kettleby: 3, matt: 2 } },
        { t: 'Birthday brunch for someone',      w: { cakely: 3, ameer: 2 } },
        { t: 'Long walk, good playlist',         w: { sunny: 3, cary: 2 } },
        { t: 'Inbox zero by ten',                w: { javi: 3, cooker: 2, pea: 1 } }
      ] }
  ];

  /* Prize tiers. Each 'code' must exist as a Shopify discount with
     "Limit to one use per customer" checked — that is what enforces one per email,
     server-side at checkout, without any backend of our own. */
  var PRIZES = [
    { code: 'POP10',    label: '10% off',            note: '10% off your order',                 weight: 34, color: '#00A99D' },
    { code: 'FREESHIP', label: 'Free shipping',      note: 'Free shipping, any order size',      weight: 24, color: '#F28711' },
    { code: 'POP15',    label: '15% off',            note: '15% off your order',                 weight: 20, color: '#D22A6F' },
    { code: 'BONUSBAG', label: 'Free bag',           note: 'A free bag on orders over $35',      weight: 11, color: '#7936AD' },
    { code: 'POP20',    label: '20% off',            note: '20% off your order',                 weight: 8,  color: '#5C6B25' },
    { code: 'BOGO',     label: 'Buy 1 get 1',        note: 'Buy one bag, get one free',          weight: 3,  color: '#C9A227' }
  ];

  function pickPrize() {
    var total = PRIZES.reduce(function (s, p) { return s + p.weight; }, 0);
    var r = Math.random() * total;
    for (var i = 0; i < PRIZES.length; i++) {
      r -= PRIZES[i].weight;
      if (r <= 0) return i;
    }
    return 0;
  }

  function emailKey(email) {
    return 'belles:spun:' + String(email).trim().toLowerCase();
  }
  function alreadySpun(email) {
    try { return localStorage.getItem(emailKey(email)); } catch (e) { return null; }
  }
  function recordSpin(email, code) {
    try { localStorage.setItem(emailKey(email), code); } catch (e) {}
  }

  // flip labels past the halfway mark so none of them read upside-down
  function labelRot(deg) {
    return (deg > 90 && deg < 270) ? deg + 180 : deg;
  }

  function wheelSvg() {
    var n = PRIZES.length, seg = 360 / n, parts = '';
    for (var i = 0; i < n; i++) {
      var a0 = (i * seg - 90) * Math.PI / 180, a1 = ((i + 1) * seg - 90) * Math.PI / 180;
      var x0 = 100 + 96 * Math.cos(a0), y0 = 100 + 96 * Math.sin(a0);
      var x1 = 100 + 96 * Math.cos(a1), y1 = 100 + 96 * Math.sin(a1);
      parts += '<path d="M100,100 L' + x0.toFixed(1) + ',' + y0.toFixed(1)
        + ' A96,96 0 0,1 ' + x1.toFixed(1) + ',' + y1.toFixed(1) + ' Z" fill="' + PRIZES[i].color + '"/>';
      var mid = (i * seg + seg / 2 - 90) * Math.PI / 180;
      var tx = 100 + 62 * Math.cos(mid), ty = 100 + 62 * Math.sin(mid);
      parts += '<text x="' + tx.toFixed(1) + '" y="' + ty.toFixed(1) + '" fill="#fff" font-size="11" font-weight="700"'
        + ' text-anchor="middle" dominant-baseline="middle"'
        + ' transform="rotate(' + labelRot(i * seg + seg / 2) + ' ' + tx.toFixed(1) + ' ' + ty.toFixed(1) + ')">'
        + PRIZES[i].label + '</text>';
    }
    return '<svg viewBox="0 0 200 200" class="wheel__svg" aria-hidden="true">' + parts
      + '<circle cx="100" cy="100" r="97" fill="none" stroke="#2B1B12" stroke-width="6"/>'
      + '<circle cx="100" cy="100" r="14" fill="#F8F6E5" stroke="#2B1B12" stroke-width="5"/></svg>';
  }

  function assetUrl(root, file) {
    var base = root.getAttribute('data-asset-base') || 'shopify-theme/assets/';
    return base + file;
  }
  function productUrl(root, handle) {
    var mode = root.getAttribute('data-product-base');
    return mode ? mode + handle : 'product-' + handle + '.html';
  }

  /* Email capture. On Shopify the form posts to the real customer endpoint
     (data-customer-form supplies the markup), so the address lands in Customers
     with marketing consent — no app, no third party. */
  function renderEmailGate(box, character) {
    if (!box) return;
    box.innerHTML =
      '<div class="spin">'
      + '<h3 class="spin__h">One more thing — spin for a discount</h3>'
      + '<p class="spin__lead">Add your email and give the wheel a spin. One spin per email address.</p>'
      + '<form class="spin__form" novalidate>'
      + '<input type="email" name="email" placeholder="you@email.com" aria-label="Email address" required>'
      + '<button type="submit" class="btn">Unlock my spin</button>'
      + '</form>'
      + '<p class="spin__err" role="alert"></p>'
      + '<p class="spin__fine">We’ll send the occasional flavor drop and nothing else. Unsubscribe any time.</p>'
      + '</div>';

    var form = box.querySelector('form');
    var err = box.querySelector('.spin__err');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[name=email]').value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        err.textContent = 'That email does not look right — check it and try again.';
        return;
      }
      var prior = alreadySpun(email);
      if (prior) {
        renderPrize(box, PRIZES.filter(function (p) { return p.code === prior; })[0] || PRIZES[0], email, true);
        return;
      }
      submitCustomer(email);
      renderWheel(box, email, character);
    });
  }

  /* Posts the address to Shopify's own customer form in the background.
     Never form.submit() here: that navigates the page and destroys the wheel
     before the shopper ever sees their prize. */
  function submitCustomer(email) {
    var tpl = document.querySelector('[data-customer-form]');
    if (!tpl) return;                       // preview: nothing to post to
    var f = tpl.querySelector('form');
    if (!f || !f.action) return;
    var input = f.querySelector('input[type=email]');
    if (input) input.value = email;
    try {
      var body = new FormData(f);
      fetch(f.action, { method: 'POST', body: body, credentials: 'same-origin' })
        .catch(function () { /* signup is best-effort; never block the prize */ });
    } catch (e) {}
  }

  function renderWheel(box, email, character) {
    var idx = pickPrize();
    box.innerHTML =
      '<div class="spin">'
      + '<h3 class="spin__h">Give it a spin</h3>'
      + '<div class="wheel"><div class="wheel__rotor" data-rotor>' + wheelSvg() + '</div>'
      + '<span class="wheel__pin" aria-hidden="true"></span></div>'
      + '<button type="button" class="btn btn--lg" data-go>Spin the wheel</button>'
      + '</div>';

    var rotor = box.querySelector('[data-rotor]');
    var go = box.querySelector('[data-go]');
    go.addEventListener('click', function () {
      go.disabled = true;
      go.textContent = 'Spinning…';
      var seg = 360 / PRIZES.length;
      // land the pin (top) in the middle of the winning segment, after 4 full turns
      var target = 360 * 4 + (360 - (idx * seg + seg / 2));
      rotor.style.transform = 'rotate(' + target + 'deg)';
      setTimeout(function () {
        recordSpin(email, PRIZES[idx].code);
        renderPrize(box, PRIZES[idx], email, false);
      }, 4200);
    });
  }

  function renderPrize(box, prize, email, repeat) {
    box.innerHTML =
      '<div class="spin spin--won">'
      + '<h3 class="spin__h">' + (repeat ? 'You’ve already spun — here it is again' : 'You won ' + prize.label + '!') + '</h3>'
      + '<p class="spin__lead">' + prize.note + '. Use this code at checkout.</p>'
      + '<div class="spin__code"><code>' + prize.code + '</code>'
      + '<button type="button" class="btn btn--sm" data-copy>Copy</button></div>'
      + '<p class="spin__fine">Save this code — one use per customer. Added to the family list as ' + email + '.</p>'
      + '</div>';
    var btn = box.querySelector('[data-copy]');
    btn.addEventListener('click', function () {
      if (navigator.clipboard) navigator.clipboard.writeText(prize.code);
      btn.textContent = 'Copied';
      setTimeout(function () { btn.textContent = 'Copy'; }, 1800);
    });
  }

  function mount(root) {
    if (!root) return;
    var answers = [];
    var step = 0;

    function scoreWinner() {
      var totals = {};
      answers.forEach(function (opt) {
        Object.keys(opt.w).forEach(function (k) { totals[k] = (totals[k] || 0) + opt.w[k]; });
      });
      var best = null, bestVal = -1;
      Object.keys(CHARS).forEach(function (k) {
        var v = totals[k] || 0;
        if (v > bestVal) { bestVal = v; best = k; }
      });
      return best;
    }

    function renderIntro() {
      root.innerHTML =
        '<div class="quiz__card quiz__intro">'
        + '<p class="eyebrow">Popcorn With Personality</p>'
        + '<h1 class="quiz__h">What\u2019s Your Popcorn Personality?</h1>'
        + '<p class="quiz__lead">Six quick questions and we\u2019ll match you with the character \u2014 and the bag \u2014 that is most you. Finish and you get a spin of the discount wheel.</p>'
        + '<button type="button" class="btn btn--lg" data-start>Start the quiz</button>'
        + '</div>';
      root.querySelector('[data-start]').addEventListener('click', function () { step = 0; renderQuestion(); });
    }

    function renderQuestion() {
      var q = QUESTIONS[step];
      var pct = Math.round(step / QUESTIONS.length * 100);
      root.innerHTML =
        '<div class="quiz__card">'
        + '<div class="quiz__meta"><span class="label">Question ' + (step + 1) + ' of ' + QUESTIONS.length + '</span>'
        + (step > 0 ? '<button type="button" class="quiz__back" data-back>\u2190 Back</button>' : '')
        + '</div>'
        + '<div class="track"><i style="width:' + pct + '%"></i></div>'
        + '<h2 class="quiz__q">' + q.q + '</h2>'
        + '<div class="quiz__opts">'
        + q.a.map(function (o, i) {
            return '<button type="button" class="quiz__opt" data-i="' + i + '">' + o.t + '</button>';
          }).join('')
        + '</div></div>';

      [].slice.call(root.querySelectorAll('.quiz__opt')).forEach(function (b) {
        b.addEventListener('click', function () {
          answers[step] = q.a[parseInt(b.getAttribute('data-i'), 10)];
          step++;
          if (step >= QUESTIONS.length) renderResult(); else renderQuestion();
        });
      });
      var back = root.querySelector('[data-back]');
      if (back) back.addEventListener('click', function () { step--; renderQuestion(); });
      var first = root.querySelector('.quiz__opt');
      if (first) first.focus();
    }

    /* The three flavors the result recommends, named so the shopper knows what
       "Build my box" is about to put in front of them. */
    function recsHtml(key) {
      var keys = [key].concat(KIN[key] || []);
      var rows = keys.map(function (k) {
        var x = CHARS[k];
        if (!x) return '';
        return '<li><span class="quiz__recname">' + x.flavor + '</span>'
          + '<span class="quiz__recwho">' + x.name + '</span></li>';
      }).join('');
      if (!rows) return '';
      return '<div class="quiz__recs"><span class="label">Your flavors</span><ul>' + rows + '</ul></div>';
    }

    function renderResult() {
      var key = scoreWinner();
      var c = CHARS[key];
      root.innerHTML =
        '<div class="quiz__card quiz__result">'
        + '<p class="eyebrow">It\u2019s a match</p>'
        + '<h2 class="quiz__h">You are ' + c.name + '</h2>'
        + '<div class="pcard" style="--pcard-bg:' + c.accent + '">'
        + '<div class="pcard__art"><img src="' + assetUrl(root, c.art) + '" alt="' + c.name + '"></div>'
        + '<div class="pcard__body">'
        + '<p class="pcard__blurb">' + c.blurb + '</p>'
        + '<div class="pcard__flavor">' + c.flavor + '</div>'
        + '</div></div>'
        + '<p class="quiz__lead">Your bag is <strong>' + c.flavor + '</strong>. Try our delicious, reinvented, better-for-you popcorn.</p>'
        + recsHtml(key)
        + '<div class="quiz__actions">'
        + '<a class="btn btn--lg" href="' + boxUrl(root, [key].concat(KIN[key] || [])) + '">Build my box</a>'
        + '<a class="btn btn--lg btn--secondary" href="' + productUrl(root, c.handle) + '">Shop ' + c.flavor + '</a>'
        + '<button type="button" class="btn btn--ghost" data-again>Take it again</button>'
        + '</div>'
        + '<div class="quiz__spin" data-spin></div>'
        + '</div>';
      root.querySelector('[data-again]').addEventListener('click', function () { answers = []; renderIntro(); });
      renderEmailGate(root.querySelector('[data-spin]'), c);
    }

    renderIntro();
  }

  window.BellesQuiz = { mount: mount, CHARS: CHARS, QUESTIONS: QUESTIONS };

  document.addEventListener('DOMContentLoaded', function () {
    [].slice.call(document.querySelectorAll('[data-belles-quiz]')).forEach(mount);
  });
})();
